module.exports = __webpack_public_path__ + "img/chain.747d34f2.svg";